import cx from 'classnames';

import './CircleMarker.scss';

interface CircleMarkerProps {
  large: boolean;
  order: number;
}

const defaultProps = {
  large: false,
  order: 1,
};

function CircleMarker({ large, order }: CircleMarkerProps) {
  const className = cx('CircleMarker', {
    'CircleMarker--large': large,
    'CircleMarker--1st': order === 1,
    'CircleMarker--2nd': order === 2,
    'CircleMarker--3rd': order === 3,
    'CircleMarker--4th': order === 4,
    'CircleMarker--5th': order === 5,
  });

  return <i className={className} />;
}

CircleMarker.defaultProps = defaultProps;

export default CircleMarker;
